import { Platform, View } from "react-native"
import { H1, H3, H5, Tiny } from "@/components/standard/BFText"

interface HeaderValueProps {
  title: string
  value: string
  borderRight: boolean
}

const HeaderValue: React.FC<HeaderValueProps> = ({
  title,
  value,
  borderRight,
}: HeaderValueProps) => (
  <View
    className={`flex flex-col flex-1 items-center justify-center ${borderRight ? "border-r border-r-light-grey" : ""}`}
  >
    <Tiny className="text-white text-center w-[60px] pt-2 pb-1">{title}</Tiny>
    <H3 className=" text-white text-center">{value}</H3>
  </View>
)

interface HeaderProps {
  balance: string
  pointsValue: string
  availableReferrals: string
  spent: string
  onDismiss: () => void
}

export const RewardsHeader: React.FC<HeaderProps> = ({
  balance,
  pointsValue,
  availableReferrals,
  spent,
  onDismiss,
}: HeaderProps) => (
  <View
    className="flex flex-col h-[190px]"
    style={{ marginTop: Platform.OS === "web" ? 16 : 48 }}
  >
    <View className="flex flex-col items-center justify-center pt-8 mx-6 border-b border-b-light-grey">
      <Tiny className="text-teal">YOUR POINTS</Tiny>
      <H1 className="text-[36px] text-teal leading-[42px]">{balance}</H1>
    </View>
    <View className="flex flex-row mx-6 justify-evenly">
      <HeaderValue
        title="POINTS VALUE"
        value={pointsValue}
        borderRight={true}
      />
      <HeaderValue
        title="AVAILABLE REFERRALS"
        value={availableReferrals}
        borderRight={true}
      />
      <HeaderValue title="POINTS USED" value={spent} borderRight={false} />
    </View>
    <H5 className="text-white text-center pt-6">
      10 POINTS = $1 TOWARDS CLOSING COSTS
    </H5>
  </View>
)
